import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

/**
 * The title of a sidebar list with the number of items in it, which the
 * message places through its `{count}` value. The count is set in the
 * monospaced meta style, quieter than the title.
 */
export default function SectionTitle({
    id,
    count,
    countTestId,
}: {
    /** Message id of the title, with a `{count}` value. */
    id: string;
    count: number;
    countTestId?: string;
}) {
    return (
        <Typography
            component="h3"
            fontSize={14}
            fontWeight={500}
            flex={1}
            minWidth={0}
            noWrap
        >
            <FormattedMessage
                id={id}
                values={{
                    count: (
                        <Typography
                            component="span"
                            variant="monoMeta"
                            fontSize={14}
                            color="text.secondary"
                            ml="2px"
                            data-testid={countTestId}
                        >
                            {count}
                        </Typography>
                    ),
                }}
            />
        </Typography>
    );
}
